import { ContrastGraphQLFieldConfig } from '..'
import { Context } from '../shared'
import { organizationDigestSettingsType } from '../types/organization-digest-settings'
import { GraphQLNonNull, GraphQLID } from 'graphql'

interface OrganizationDigestSettingsQueryArgs {
  readonly organizationID: string
}

interface OrganizationDigestSettingsQueryResponse {
  readonly id: string
  readonly compliance: boolean
  readonly remediation: boolean
  readonly library: boolean
}

export const organizationDigestSettings: ContrastGraphQLFieldConfig<
  any,
  Context,
  OrganizationDigestSettingsQueryArgs,
  OrganizationDigestSettingsQueryResponse
> = {
  description: 'Get digest settings by organization ID',
  type: new GraphQLNonNull(organizationDigestSettingsType),
  args: {
    organizationID: {
      description: 'The unique ID for the organization being queried',
      type: new GraphQLNonNull(GraphQLID)
    }
  },
  async resolve(_source, args, context) {
    const { organizationID } = args

    const { settings } = await context.connector.get(
      `/${organizationID}/notifications/organization`
    )

    const {
      digest_compliance: compliance,
      digest_remediation: remediation,
      digest_library: library
    } = settings

    return {
      id: organizationID,
      compliance,
      remediation,
      library
    }
  }
}
